import { defineStore } from 'pinia';
import { useAccountStore } from '@/stores/account';
import { useUserStore, USER_SETTINGS_KEYS } from '@/stores/user';
import companyProfileExamples from '@/data/companyProfileExamples';

export const useSearchHistoryStore = defineStore('searchHistory', {
    state: () => {
        const accountStore = useAccountStore();
        const accountId = accountStore?.account?.account_id ?? null;
        const userSettings = useUserStore().getSettings(USER_SETTINGS_KEYS.searchHistory, accountId);

        return {
            maxItems: 25,
            history: accountId
                ? (userSettings?.history ?? [])
                : (JSON.parse(localStorage.getItem('pp_user_search_history')) ?? []),
        };
    },
    getters: {
        historyAndExamples: (state) => (limit) => {
            const isAuthenticated = useUserStore().isAuthenticated;
            let items = [...state.history];
            const itemsNeeded = limit - items.length;

            if (itemsNeeded > 0) {
                const historyIds = new Set(items.map(item => item.id));
                const filteredExamples = companyProfileExamples.filter(
                    example => !Array.from(historyIds).some(id => (isAuthenticated && id.split('_')[0] === example.id.split('_')[0]) || id === example.id)
                );
                items = items.concat(filteredExamples.slice(0, itemsNeeded));
            }

            return items;
        },
    },
    actions: {
        add(company) {
            if (!company?.id || !company?.name) return;

            const userStore = useUserStore();
            const id = userStore.isAuthenticated
                ? company.id
                : company.ch ? `${company.id}_${company.ch}` : company.id;

            this.history = this.history.filter(item => item.id !== id);
            if (this.history.length >= this.maxItems) this.history.pop();
            this.history.unshift({ id, name: company.name, domain: company.domain || null, timestamp: Date.now() });

            this._save();
        },
        remove(id) {
            this.history = this.history.filter(item => item.id !== id);
            this._save();
        },
        clear() {
            this.history = [];
            this._save();
        },
        _save() {
            const accountStore = useAccountStore();
            const accountId = accountStore?.account?.account_id ?? null;

            if (accountId) {
                useUserStore().saveSettings(USER_SETTINGS_KEYS.searchHistory, accountId, this.history?.length ? { history: this.history } : null);
            } else {
                localStorage.setItem('pp_user_search_history', JSON.stringify(this.history));
            }
        },
    },
});
